import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Type definitions
export interface User {
  email: string;
  [key: string]: any;
}

export interface AuthState {
  // State
  token: string | null;
  user: User | null;
  isAuthenticated: boolean;

  // Actions
  setToken: (token: string) => void;
  setUser: (user: User) => void;
  login: (token: string, user: User) => void;
  logout: () => void;
  getToken: () => string | null;
  updateToken: (newToken: string) => void;
}

const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      // State
      token: null,
      user: null,
      isAuthenticated: false,

      // Actions
      setToken: (token: string) => set({ token, isAuthenticated: !!token }),

      setUser: (user: User) => set({ user }),

      login: (token: string, user: User) => set({
        token,
        user,
        isAuthenticated: true
      }),

      logout: () => set({
        token: null,
        user: null,
        isAuthenticated: false
      }),

      // Helper to get token for API calls
      getToken: () => get().token,

      // Update token (for refresh scenarios)
      updateToken: (newToken: string) => set({ token: newToken }),
    }),
    {
      name: 'auth-storage', // localStorage key
      partialize: (state) => ({
        token: state.token,
        user: state.user,
        isAuthenticated: state.isAuthenticated
      }), // Only persist these fields
    }
  )
);

export default useAuthStore;
